module.exports = __webpack_public_path__ + "img/icon2.cd33451f.png";